import React from 'react';
import LinkIconButton from '../Formater/LinkIconButton';
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core';
import PhoneLinkButton from '../Formater/PhoneLinkButton';

const RenderContactDetailsFragment = ({contact, hideDescription, hideName, classes}) => {
    return (
        <React.Fragment>
            {!hideName && (<div>{contact.first_name} &nbsp; {contact.last_name}</div>)}
            {!hideDescription && contact.description && (<Typography variant={'subtitle2'} component={'div'}>{contact.description}</Typography>)}
            {/*{contact.department && (<div>{contact.department}</div>)}*/}
            {contact.landline && (
                <div>
                    <PhoneLinkButton text={contact.landline} />
                </div>
            )}
            {contact.mobile && (
                <div>
                    <PhoneLinkButton text={contact.mobile} icon={'smartphone'} />
                </div>
            )}
            {contact.email && (
                <div>
                    <LinkIconButton
                        text={contact.email}
                        href={`mailto:${contact.email}`}
                        icon={'mail'}
                    />
                </div>
            )}
        </React.Fragment>
    );
};

const styles = theme => ({

});

export default withStyles(styles)(RenderContactDetailsFragment);
